import { fillMissingUnitNames } from 'src/helpers/utilities';
import { mapSubUnitsInfoToAvailableSubUnits } from 'src/helpers/houses/sub_units_mapper';
import { user_data } from 'src/stores/account/user';
import type { UserData } from 'src/types/UserData';
import type { GetUnitsInfoResponse } from 'src/types/responses/getUnitsInfoResponse';

/**
 * Applies a successful `/user/get_units_info` payload to `user_data`
 * (`available_units`, `available_sub_units`). No-op if the response is
 * not ok or has no `data` envelope.
 */
export const mergeGetUnitsInfoIntoUserData = (response: GetUnitsInfoResponse): void => {
	if (!response?.isok || !response.data) {
		return;
	}

	const { data } = response;
	const updates: Partial<UserData> = {};

	if (data.own_units) {
		updates.available_units = fillMissingUnitNames(data.own_units);
	}

	if (Array.isArray(data.sub_units)) {
		// Always assign — empty array maps to `{}` so revoked shares get cleared.
		updates.available_sub_units = mapSubUnitsInfoToAvailableSubUnits(data.sub_units);
	}

	if (Object.keys(updates).length > 0) {
		user_data.update(updates);
	}
};
